import { Page } from '../../../src/landing/flu-vaccine/Page';

// eslint-disable-next-line import/no-default-export
export default Page;
